import { PLATFORM } from 'aurelia-framework';

export class ColumnsGenerator {
    generate(cartViewConfig, order) {
        if (!cartViewConfig) {
            return [];
        }

        const result = this._getDisplayedColumns(cartViewConfig, order);

        result.has = function (id) {
            let found = false;

            this.forEach((column) => {
                if (column.id === id) {
                    found = true;
                    return false;
                }
            });

            return found;
        };

        result.indexOf = function (id) {
            let _key = null;

            this.forEach((column, key) => {
                if (column.id === id) {
                    _key = key;
                    return false;
                }
            });

            return _key;
        };

        let itemPriceIndex = result.indexOf('itemPrice');
        let priceIndex = result.indexOf('price');

        let index = Math.min(
            result.indexOf('itemPrice'),
            result.indexOf('price')
        );
        let hasBothColumns = itemPriceIndex > 0 && priceIndex > 0;

        if (index > 0) {
            result.footer = {
                skipColspanLeft: index,
                hasBothColumns: hasBothColumns,
                skipColspanRight:
                    result.length - (index + (hasBothColumns ? 2 : 1)),
            };
        }

        return result;
    }

    _getDisplayedColumns(cartViewConfig, order) {
        if (!cartViewConfig || !cartViewConfig.columns) {
            return [];
        }

        console.log('CARTVIEWCONFIG', cartViewConfig, order);

        const columns = this._cloneColumnsWithRegardsToOrder(
            cartViewConfig.columns,
            order
        );

        columns.forEach((column) => this._addViewToColumn(column));

        return columns;
    }

    _cloneColumnsWithRegardsToOrder(columns, order) {
        // clone columns with regards to order in src/order/tourism/cart-view/items-list-header.html

        const requiredOrder = [
            'sortable',
            'selectable',
            'colorCode',
            'title',
            'b2bGroup',
            'hotelRating',
            'fromDate',
            'toDate',
            'itemDuration',
            'amount',
            'roomAmount',
            'serviceProvider',
            'purchaseCancellation',
            'purchaseRequestOptionDate',
            'APInvoices',
            'purchasePrice',
            'calculatedPurchaseUnitPrice',
            'calculatedPurchasePrice',
            'taxPercentage',
            'price',
            'itemPrice',
            'commission',
            'status',
            'edit',
        ];

        if (!order.isb2b) {
            const b2bGroupIndex = requiredOrder.indexOf('b2bGroup');
            if (b2bGroupIndex > -1) {
                requiredOrder.splice(b2bGroupIndex, 1);
            }
        }

        const result = [];

        requiredOrder.forEach((columnId) => {
            const column = columns.find((column) => column.id === columnId);
            if (column) {
                result.push(column);
            }
        });

        return result;
    }

    _addViewToColumn(column) {
        column.view = './columns/column-' + column.id + '.html';
    }
}

PLATFORM.moduleName('./column-amount.html');
PLATFORM.moduleName('./column-roomAmount.html');
PLATFORM.moduleName('./column-APInvoices.html');
PLATFORM.moduleName('./column-colorCode.html');
PLATFORM.moduleName('./column-commission.html');
PLATFORM.moduleName('./column-edit.html');
PLATFORM.moduleName('./column-fromDate.html');
PLATFORM.moduleName('./column-price.html');
PLATFORM.moduleName('./column-purchaseCancellation.html');
PLATFORM.moduleName('./column-purchaseRequestOptionDate.html');
PLATFORM.moduleName('./column-taxPercentage.html');
PLATFORM.moduleName('./column-itemPrice.html');
PLATFORM.moduleName('./column-purchasePrice.html');
PLATFORM.moduleName('./column-hotelRating.html');
PLATFORM.moduleName('./column-calculatedPurchasePrice.html');
PLATFORM.moduleName('./column-calculatedPurchaseUnitPrice.html');
PLATFORM.moduleName('./column-selectable.html');
PLATFORM.moduleName('./column-serviceProvider.html');
PLATFORM.moduleName('./column-sortable.html');
PLATFORM.moduleName('./column-status.html');
PLATFORM.moduleName('./column-title.html');
PLATFORM.moduleName('./column-b2bGroup.html');
PLATFORM.moduleName('./column-toDate.html');
PLATFORM.moduleName('./column-itemDuration.html');
